import React from 'react'
import StyledH5Heading from '../../../common/components/styledH5Heading/StyledH5Heading'
import LinkedButton from '../../../components/linkedButton/LinkedButton'
import StyledSmText from '../../../common/components/styledSmText/StyledSmText'
import StyledH6Heading from '../../../common/components/styledH6Heading/StyledH6Heading'

const BeAPartSection = () => {
    return (
        <div className='w-[90%] text-white flex flex-col gap-10 md:gap-20 py-20 items-center'>
            <div className='flex flex-col items-start gap-5 md:w-[90%]'>
                <div>
                    <StyledH5Heading fontColor="text-gradient">Be Part of the Open Economy of the Future.</StyledH5Heading>
                </div>
                <div>
                    <LinkedButton fontColor="text-white">Powerful features</LinkedButton>
                </div>
            </div>
            <div className='flex flex-col items-center gap-5 md:flex-row'>
                <div className='md:w-[50%] flex flex-col gap-5 md:gap-0 h-full md:justify-between bg-dull-black p-3 md:p-5'>
                    <div>
                        <StyledSmText fontColor="text-gray">INTERCHAIN ACCOUNTS</StyledSmText>
                    </div>
                    <div>
                        <img width={233} height={233} src='/assets/images/locker.webp' alt='Locker' />
                    </div>
                    <div>
                        <StyledH6Heading fontColor="text-gradient  ">One secure account for all your digital assets.</StyledH6Heading>
                    </div>
                    <div>
                        <StyledSmText fontColor="text-gray">COMING SOON</StyledSmText>
                    </div>
                </div>
                <div className='flex flex-col gap-5 md:w-[50%]'>
                    <div className='flex flex-col w-full gap-3 p-5 md:gap-0 md:justify-between bg-dull-black'>
                        <div>
                            <StyledSmText fontColor="text-gray">DECENTRALIZED EXCHANGE</StyledSmText>
                        </div>
                        <div className='flex items-center justify-between'>
                            <div>
                                <StyledH6Heading fontColor="text-gradient   whitespace-nowrap">Swap tokens.</StyledH6Heading>
                            </div>
                            <div>
                                <img width={233} height={233} src='/assets/images/swap.webp' alt='Locker' />
                            </div>
                        </div>
                        <div>
                            <StyledSmText fontColor="text-gray">COMING SOON</StyledSmText>
                        </div>
                    </div>
                    <div className='flex flex-col gap-5 md:flex-row'>
                        <div className='flex flex-col gap-5 p-5 md:gap-0 md:justify-between md:w-full bg-dull-black'>
                            <div>
                                <StyledSmText fontColor="text-gray">LIQUIDITY POOL</StyledSmText>
                            </div>
                            <div className='flex items-center justify-between'>
                                <div>
                                    <StyledH6Heading fontColor="text-gradient  ">Earn rewards.</StyledH6Heading>
                                </div>
                            </div>
                            <div>
                                <StyledSmText fontColor="text-gray">COMING SOON</StyledSmText>
                            </div>
                        </div><div className='flex flex-col w-full gap-5 p-5 md:gap-0 md:justify-between bg-dull-black'>
                            <div>
                                <StyledSmText fontColor="text-gray">WRAPPED MATIC</StyledSmText>
                            </div>
                            <div className='flex items-center justify-between'>
                                <div>
                                    <StyledH6Heading fontColor="text-gradient  ">MATIC Included</StyledH6Heading>
                                </div>
                            </div>
                            <div>
                                <StyledSmText fontColor="text-gray">COMING SOON</StyledSmText>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BeAPartSection
